import * as Sentry from '@sentry/react';

type LogLevel = 'error';

class LoggerService {
    private static instance: LoggerService;

    private constructor() {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });
    }

    public static getInstance(): LoggerService {
        if (!LoggerService.instance) {
            LoggerService.instance = new LoggerService();
        }
        return LoggerService.instance;
    }

    private log(level: LogLevel, error?: any) {
        switch (level) {
            case 'error':
                Sentry.captureException(error);
                break;
        }

    }

    error(error?: any) {
        this.log('error', error);
    }
}

const loggerService = LoggerService.getInstance();

export default loggerService;